import {
    ATTEMPT_REMOVE_MAXABLE_EXERCISE,
    CLOSE_REMOVE_MAX_POPUP,
} from 'shared_redux/actions';

export const removeMaxableExercise = (exerciseId) => ({ type: ATTEMPT_REMOVE_MAXABLE_EXERCISE, exerciseId });

export const closeModal = () => ({ type: CLOSE_REMOVE_MAX_POPUP });
